"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationErrorsToTextComponent = exports.ImageValidation = exports.ImageValidationSync = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _react = _interopRequireDefault(require("react"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _config = require("../config");

var _fileSizeHelper = require("@eig-builder/core-utils/helpers/file-size-helper");

/**
 * ImageValidator
 *
 * Takes a File (actual File type) and runs validations against it.
 * Returns a promise.
 * If successfull, the resolved promise will have an 'success' property.
 *
 * You can use .catch to get handle the errors
 * Example:
 * const checkedFile = await ImageValidation(File, ["max_size"])
 *    .catch(err => {
 *        console.log(err.errors)
 *    })
 *
 * Validating multiple files.
 * Map over the files returning promises
 * const validations = files.map(file => await ImageValidation(file))
 *
 * Resolve all promises
 * const validatedFiles = await Promise.all(validations)
 */
var ImageValidator = function ImageValidator(file) {
  var _this = this;

  var validations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['max_size', 'ext'];
  var resolve = arguments.length > 2 ? arguments[2] : undefined;
  var reject = arguments.length > 3 ? arguments[3] : undefined;
  (0, _classCallCheck2["default"])(this, ImageValidator);

  this.validate = function (type) {
    if (typeof type === 'string') {
      if (type === 'ext') {
        _this.runExtValidation();
      }

      if (type === 'max_size') {
        _this.runMaxSize();
      }
    }

    if (typeof type !== 'string') {
      if ('values' in type) {
        _this.runExtValidation(type.values);
      }
    }
  };

  this.isFile = function () {
    if (!_this.file || typeof _this.file.name !== 'string') {
      _this.errors.push(_config.NOT_A_FILE);

      return false;
    }

    return true;
  };

  this.runMaxSize = function () {
    if (_this.file.size > _config.MAX_FILE_SIZE) {
      _this.errors.push(_config.MAX_FILE);
    }
  };

  this.runExtValidation = function (values) {
    if (!(values || _config.EXT_ALLOWED).includes(_this.file.type)) {
      _this.errors.push(_config.EXT_NOT_ALLOWED);
    }
  };

  this.rejectPromise = function () {
    return _this.reject(_this.errors);
  };

  this.returnWithErrors = function () {
    return {
      errors: _this.errors
    };
  };

  this.returnWithSuccess = function () {
    return {
      success: true
    };
  };

  this.runAllValidations = function () {
    // if its not a File, then just throw and stop everything
    if (!_this.isFile()) {
      _this.rejectPromise();
    } else {
      _this.validations.forEach(function (validation) {
        return _this.validate(validation);
      });

      if (_this.errors.length > 0) {
        return _this.rejectPromise();
      }

      return _this.resolve({
        success: true
      });
    }
  };

  this.runValidationsSync = function () {
    if (!_this.isFile()) {
      return _this.returnWithErrors();
    } else {
      _this.validations.forEach(function (validation) {
        return _this.validate(validation);
      });

      if (_this.errors.length > 0) {
        return _this.returnWithErrors();
      }
    }
  };

  this.validations = validations;
  this.file = file;
  this.errors = [];
  this.resolve = resolve;
  this.reject = reject;
}; // Sync - Use a per file


var ImageValidationSync = function ImageValidationSync(file, validations) {
  var newImageValidation = new ImageValidator(file, validations);
  newImageValidation.runValidationsSync();

  if (newImageValidation.errors.length > 0) {
    return newImageValidation;
  }

  return {
    success: true
  };
}; // Async - Await all errors


exports.ImageValidationSync = ImageValidationSync;

var ImageValidation = function ImageValidation(file, validations) {
  return new Promise(function (resolve, reject) {
    var newImageValidation = new ImageValidator(file, validations, resolve, reject);
    newImageValidation.runAllValidations();

    if (newImageValidation.errors.length > 0) {
      return reject(newImageValidation);
    }

    return resolve(newImageValidation);
  });
};

exports.ImageValidation = ImageValidation;
var errors = {
  NOT_A_FILE: 'imagepicker.notAFile',
  MAX_FILE_SIZE_EXCEEDED: {
    path: 'imagepicker.fileExceedsSizeLimit',
    value: (0, _fileSizeHelper.bytesToFormattedString)(_config.MAX_FILE_SIZE)
  },
  EXTENSION_NOT_ALLOWED: 'imagepicker.fileNotSupported',
  TOO_MANY_FILES: {
    path: 'imagepicker.maxAmountOfFilesUpload',
    value: _config.MAX_AMOUNT_OF_FILES_UPLOADED_AT_ONCE
  }
}; // convert errors from our image validator to <Text /> components

var validationErrorsToTextComponent = function validationErrorsToTextComponent(errorsArray) {
  if (errorsArray && Array.isArray(errorsArray)) {
    var useDefinedErrors = errorsArray.every(function (r) {
      return Object.keys(errors).includes(r);
    });
    return errorsArray.map(function (error, index) {
      var errorObj = useDefinedErrors ? errors[error] : error;

      if (typeof errorObj === 'string') {
        return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
          key: index,
          message: "".concat(errorObj)
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
        key: index,
        message: "".concat(errorObj.path),
        values: [errorObj.value]
      });
    });
  }
}; // TODO
// Add validation for: resolution


exports.validationErrorsToTextComponent = validationErrorsToTextComponent;